import { transition, trigger, useAnimation } from '@angular/animations';
import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  fadeInFromRightAnimation,
  fadeOutToRightAnimation,
} from '../../../../shared/animations/index';
import { SimXAgreement } from '../../../../shared/models/entities/simx-agreement.model';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'agreement',
  standalone: false,
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInFromRightOutToRightAnimation', [
      transition(':enter', [
        useAnimation(fadeInFromRightAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutToRightAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class AgreementComponent implements OnDestroy, OnInit {
  private readonly _authenticationService = inject(AuthenticationService);

  subscriptions: Subscription = new Subscription();

  unsignedAgreement: SimXAgreement | null = null;

  acceptanceErrorMessage: string | null = null;
  acceptanceInProgress: boolean = false;
  showRejectionDialog: boolean = false;

  ngOnInit(): void {
    this.subscriptions.add(
      this._authenticationService
        .getUnsignedAgreements$()
        .subscribe((unsignedAgreements: Array<SimXAgreement>) => {
          this.unsignedAgreement = [...unsignedAgreements].shift() || null;
        }),
    );

    this.subscriptions.add(
      this._authenticationService
        .getIsSigningAgreement$()
        .subscribe((acceptanceState: boolean) => {
          this.acceptanceInProgress = acceptanceState;
        }),
    );

    this.subscriptions.add(
      this._authenticationService
        .getSignAgreementFailed$()
        .subscribe((error: string) => {
          this.acceptanceErrorMessage = error;
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleDialog(): void {
    this.showRejectionDialog = !this.showRejectionDialog;
  }

  handleDisagreeActionClick(): void {
    this.toggleDialog();
  }

  onAgreementRejectionSubmit(): void {
    this.showRejectionDialog = false;
    this._authenticationService.requestLogout();
  }

  onAgreementAcceptanceSubmit(): void {
    this.acceptanceErrorMessage = null;

    this._authenticationService.requestSignAgreement(this.unsignedAgreement.id);
  }
}
